export function kmhToMs(kmh: number): number {
  // 1 km/h = 1000m / 3600s = 0.2777... m/s
  return kmh * (1000 / 3600);
}

export function msToKmh(ms: number): number {
  // 1 m/s = 3.6 km/h
  return ms * 3.6;
}
